const UPDATE_PLOT_LINE_VALUE = 'UPDATE_PLOT_LINE_VALUE';
const UPDATE_PLOT_LINE_DASH_STYLE = 'UPDATE_PLOT_LINE_DASH_STYLE';
const UPDATE_PLOT_LINE_LABEL = 'UPDATE_PLOT_LINE_LABEL';
const UPDATE_PLOT_LINE_LABEL_POSITION = 'UPDATE_PLOT_LINE_LABEL_POSITION';
const UPDATE_PLOT_LINE_COLOR = 'UPDATE_PLOT_LINE_COLOR';
const ADD_VIEW = 'ADD_VIEW';
const REMOVE_PLOTLINE = 'REMOVE_PLOTLINE';
const MUST_RENDER_FALSE = 'MUST_RENDER_FALSE';

function updatePlotLineValue(value, id) {
  return { type: UPDATE_PLOT_LINE_VALUE, value, id };
}

function updatePlotLineDashStyle(value, id) {
  return { type: UPDATE_PLOT_LINE_DASH_STYLE, value, id };
}

function updatePlotLineLabel(value, id) {
  return { type: UPDATE_PLOT_LINE_LABEL, value, id };
}

function updatePlotLineLabelPosition(value, id) {
  return { type: UPDATE_PLOT_LINE_LABEL_POSITION, value, id };
}

function updatePlotLineColor(value, id) {
  return { type: UPDATE_PLOT_LINE_COLOR, value, id };
}

function addView(color) {
  return { type: ADD_VIEW, color };
}

function removePlotLine(id, color) {
  return { type: REMOVE_PLOTLINE, id, color };
}

export {
  UPDATE_PLOT_LINE_VALUE,
  UPDATE_PLOT_LINE_DASH_STYLE,
  UPDATE_PLOT_LINE_LABEL,
  UPDATE_PLOT_LINE_LABEL_POSITION,
  UPDATE_PLOT_LINE_COLOR,
  ADD_VIEW,
  REMOVE_PLOTLINE,
  MUST_RENDER_FALSE,
  updatePlotLineValue,
  updatePlotLineDashStyle,
  updatePlotLineLabel,
  updatePlotLineLabelPosition,
  updatePlotLineColor,
  addView,
  removePlotLine,
};
